/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { ApiRequestBuilderNavigationMetadata } from './api/index.js';
/**
 * Uri template for the request builder.
 */
export const AdminRequestBuilderUriTemplate = "{+baseurl}/admin";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const AdminRequestBuilderNavigationMetadata = {
    api: {
        navigationMetadata: ApiRequestBuilderNavigationMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=index.js.map